import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import {
  BranchDto,
  CvDto, CvFilterDto,
  RoleDto,
  SearchDto,
  TechnologyDto,
  UserAccountDto
} from 'src/app/services/api-client/models';
import {
  BranchRestControllerService,
  CvRestControllerService,
  ProjectRoleRestControllerService,
  TechnologyRestControllerService,
  UserAccountRestControllerService
} from 'src/app/services/api-client/services';
import { CvTypeEnum } from 'src/app/shared/enums/cvType.model';
import { GreybeeRoles } from 'src/app/shared/enums/greybeeRoles.model';
import { LanguageEnum } from 'src/app/shared/enums/language.model';
import { ProjectTypeEnum } from 'src/app/shared/enums/project-type.model';
import { ProjectApproaches } from 'src/app/shared/enums/projectApproach.model';
import { SearchCriteriaEnum } from 'src/app/shared/enums/searchCriteria';
import { UserStoreService } from 'src/app/services/user-store.service';
import { convertCvFilterModelToDto, FilterViewModel } from './models/view-model';
import { CvFilterModel } from './models/filter-model';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDeletionPopupComponent } from 'src/app/shared/components/confirm-deletion-popup/confirm-deletion-popup.component';

export interface SearchCriterion {
  filterName: SearchCriteriaEnum,
  filterValues: string[]
}

@Component({
  selector: 'app-search-overview',
  templateUrl: './search-overview.component.html',
  styleUrls: ['./search-overview.component.scss']
})
export class SearchOverviewComponent implements OnInit, AfterViewInit {

  cvType: CvTypeEnum = CvTypeEnum.ORIGIN_CV;
  searchForm: any;
  simpleSearchForm: any;
  selectForm: any;
  page: number = 1;
  subscription: Subscription;
  filter: SearchCriteriaEnum;
  cvList: SearchDto[] = [];
  branches: BranchDto[] = [];
  projRoles: RoleDto[] = [];
  technologies: TechnologyDto[] = [];
  multiCriteria = [
    SearchCriteriaEnum.ROLE_GREYBEE, SearchCriteriaEnum.BRANCH_SKILLS,
    SearchCriteriaEnum.PROJECT_TYPE, SearchCriteriaEnum.PROJECT_APPROACH,
    SearchCriteriaEnum.TECHNOLOGIES, SearchCriteriaEnum.ROLE_IN_PROJECT
  ]
  //PAGINATION
  itemsPerPage = 10000;
  currentPage = 1;
  totalItems: number;

  criteriaOffer: string[] = [];
  enablePlus = false;
  enableDropdown = false;
  removedItems = false;
  isSimpleSearch = true;
  offersDisabled = false;
  indexTmpSimple: number;
  indexTmpMulti: number;
  minLenght = 1;
  rowNumber = -2;
  selectedCriteria: SearchCriterion[] = [];
  allCvs: CvDto[] = [];
  displayedColumns = ['firstName', 'lastName', 'language', 'actions'];
  dataSource = new MatTableDataSource<SearchDto>();
  @ViewChild(MatPaginator) paginator: MatPaginator;

  showDeleteButton = false;

  nameList_: string[];
  lastnameList_: string[];
  userroleList_: string[];
  branchList_: string[];
  languageList_: string[];
  certificateList_: string[];
  itcompetenceList_: string[];
  professionalcompList_: string[];
  customerList_: string[];
  projectTypeList_: string[];
  projectApproachList_: string[];
  projectroleList_: string[];
  technologyList_: string[];

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private userAccountService: UserAccountRestControllerService,
    private brancheService: BranchRestControllerService,
    private roleService: ProjectRoleRestControllerService,
    private technoService: TechnologyRestControllerService,
    private translate: TranslateService,
    private cvService: CvRestControllerService,
    private toastrService: ToastrService,
    private userStore: UserStoreService,
    private dialog: MatDialog
  ) {
  }

  ngOnInit(): void {
    this.translate.use('de');
    this.searchForm = this.fb.group({
      searchCriteria: new FormArray([], [Validators.required])
    });
    this.simpleSearchForm = this.fb.group({
      freeText: new FormControl('', [Validators.required])
    });
    this.selectForm = this.fb.group({
      criteriaOffer: new FormControl()
    })
    this.loadCriteriaOffer();
    this.getBranches();
    this.getRoles();
    this.getTechnologies();
    this.cvService.getCvsBySearchText({
      pageNumber: this.currentPage - 1,
      pageSize: this.itemsPerPage,
      text: this.simpleSearchForm.get('freeText').value
    })
      .subscribe((res: SearchDto[]) => {
        this.cvList = res;
        this.convert();
        this.allCvs = this.cvList;
      });
    this.totalItems = this.cvList.length;
    this.isSimpleSearch = true;
    this.showDeleteButton = this.userStore.isTechnicalAdmin();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  convert() {
    this.cvList.forEach((cv: any) => {
      cv.language = (cv.language != 'ENGLISH') ? 'Deutsch' : 'Englisch';
    });
    this.dataSource.data = this.cvList;
  }

  checkDisability() {
    this.offersDisabled = ((this.searchForm.invalid && this.searchForm.get('searchCriteria').controls.length != 0
      && !this.removedItems) || this.indexTmpMulti > -1);
  }

  get searchCriteria(): FormArray {
    return this.searchForm.get('searchCriteria') as FormArray;
  };

  isChoosen(val: string): boolean {
    return this.filter == val;
  }

  // TODO: duplicates shall be filtered in the backend and not in the frontend
  noDuplicates(i: number, val: string): boolean {
    let noDupl = true;
    let arr = this.searchCriteria.controls[i].get('filterValues').value;
    if (arr) {
      (arr).forEach(fval => {
        if (fval.searchValue == val) {
          noDupl = false;
        }
      });
    }
    return noDupl;
  }


  onSelect(i: number, selectedValue: string) {
    if (i == -2) i = this.searchCriteria.length - 1;
    let filterValuesArr = this.searchCriteria.controls[i].get('filterValues') as FormArray;
    if (this.noDuplicates(i, selectedValue)) {
      filterValuesArr.controls[filterValuesArr.length - 1].get('searchValue').setValue(selectedValue);
    } else this.translate.get('msg_duplicate_value').subscribe((txt) => this.toastr.warning(txt, '"' + selectedValue + '"'));

    this.indexTmpMulti = -1;
    this.indexTmpSimple = -1;
    this.selectForm.get('criteriaOffer').enable();
  }

  onSelectFilterName(selectedValue: SearchCriteriaEnum) {
    let isExist = false;
    this.rowNumber = -2;
    let empty = false;
    let formArr = (this.searchCriteria as FormArray).getRawValue();
    if (formArr.length > 0) {
      formArr.forEach((element: SearchCriterion, i: number) => {
        (element.filterValues).forEach((value: any, x: number) => {
          if (value.searchValue == null || (value.searchValue && value.searchValue.lenght < 1)) {
            empty = true;
            this.removeField(i, x);

          }
        });
      });
    }
    if (formArr.length > 0) {
      formArr.forEach((element: SearchCriterion, i: number) => {
        if (element.filterName == this.translateFilterName(selectedValue)) {
          isExist = true;
          this.rowNumber = i;
          this.addEmptyField(i, selectedValue);
        }
      });
    }
    if (!isExist) {
      this.addFields(selectedValue);
    }
    this.removedItems = false;
    this.toggleInputTypes(selectedValue);
    this.selectForm.get('criteriaOffer').disable();
  }

  translateFilterName(filterName: SearchCriteriaEnum): string {
    let translation: string;
    this.translate.get('search_criteria.' + filterName).subscribe(txt => translation = txt).unsubscribe;
    return translation;
  }

  translateItems(key: string, value: string): string {
    let translation: string;
    this.translate.get(key + '.' + value).subscribe(txt => translation = txt).unsubscribe;
    return translation;
  }

  addFields(filterName: SearchCriteriaEnum) {
    (this.searchCriteria as FormArray).push(new FormGroup({
      filterName: new FormControl(this.translateFilterName(filterName)),
      filterValues: new FormArray([], Validators.required)
    }));
    this.searchCriteria.controls[this.searchCriteria.length - 1].get('filterName').disable();
    this.addEmptyField(this.searchCriteria.length - 1, filterName);
  }

  addEmptyField(i: number, filterName: SearchCriteriaEnum) {
    if (i == -2) {
      i = this.searchCriteria.length - 1;
    }
    if (this.multiCriteria.includes(filterName)) {
      this.indexTmpMulti = i;
    } else {
      this.indexTmpSimple = i;
    }
    let formArr = this.searchCriteria.controls[i].get('filterValues') as FormArray;
    formArr.push(new FormGroup({
        searchValue: new FormControl({value: null, disabled: this.multiCriteria.includes(filterName) ? true : false},
          [Validators.required])
      })
    )
  }

  toggleInputTypes(selectedTerm: SearchCriteriaEnum) {
    this.filter = selectedTerm;
    if (this.multiCriteria.includes(selectedTerm)) {
      this.enableDropdown = true;
    } else this.enableDropdown = false;
  }

  getBranches() {
    this.brancheService.getBranches().subscribe(
      (data: BranchDto[]) => {
        this.branches = data;
      })
      .unsubscribe;
  }

  getRoles() {
    this.roleService.getProjectRoles().subscribe(
      (data: RoleDto[]) => {
        this.projRoles = data;
      })
      .unsubscribe;
  }

  getFilterControls(i: number): FormGroup[] {
    return this.searchForm.get('searchCriteria').controls[i].get('filterValues').controls;
  }

  getSearchValue(i: number): AbstractControl {
    let filterValuesArr = this.searchCriteria.controls[i].get('filterValues') as FormArray;
    return filterValuesArr.controls[filterValuesArr.length - 1].get('searchValue');
  }

  getTechnologies() {
    this.technoService.getAllTechnologies().subscribe(
      (data: TechnologyDto[]) => {
        this.technologies = data;
      })
      .unsubscribe;
  }

  getProjectTypeKeys() {
    return Object.keys(ProjectTypeEnum);
  }

  loadCriteriaOffer() {
    this.criteriaOffer = Object.keys(SearchCriteriaEnum);
  }

  removeItems(i: number) {
    let fName = this.searchCriteria.controls[i].get('filterName').value;
    let fNameLast = this.searchCriteria.controls[this.searchCriteria.length - 1].get('filterName').value;
    this.searchCriteria.removeAt(i);
    this.enablePlus = false;
    this.indexTmpSimple = -1;
    this.indexTmpMulti = -1;
    if (fName == fNameLast) {
      this.removedItems = true;
      this.enableDropdown = false;
    } else this.enableDropdown = true;
    if (this.searchCriteria.length == 0) {
      this.cvList = this.allCvs;
    }
    this.selectForm.get('criteriaOffer').setValue(null);
    this.selectForm.get('criteriaOffer').enable();
  }

  removeField(row: number, valIndx: number) {
    let formArr = (this.searchCriteria.controls[row].get('filterValues') as FormArray);
    formArr.removeAt(valIndx);
    if (formArr.length == 0) this.removeItems(row);
    else {
      this.indexTmpSimple = -1;
      this.indexTmpMulti = -1;
    }
  }

  resetForm() {
    this.searchCriteria.reset();
    this.searchForm = this.fb.group({
      searchCriteria: new FormArray([], [Validators.required])
    });
    this.enablePlus = false;
  }

  checkSimpleField(i: number) {
    let value: string = this.getSearchValue(i).value;
    if (value && value.length >= this.minLenght) {
      this.selectForm.get('criteriaOffer').enable();
    }
  }

  resetLists() {
    this.nameList_ = [];
    this.lastnameList_ = [];
    this.userroleList_ = [];
    this.branchList_ = [];
    this.languageList_ = [];
    this.certificateList_ = [];
    this.itcompetenceList_ = [];
    this.professionalcompList_ = [];
    this.customerList_ = [];
    this.projectTypeList_ = [];
    this.projectApproachList_ = [];
    this.projectroleList_ = [];
    this.technologyList_ = [];
  }

  convertGreybeeRoles(filterValues: any): any {
    (filterValues).forEach((v: any) => {
      if (v.searchValue == this.translateItems('greybee_roles', 'JUNIOR_PROJECT_MANAGER')) {
        v.searchValue = GreybeeRoles.JUNIOR_PROJECT_MANAGER;
      } else if (v.searchValue == this.translateItems('greybee_roles', 'PROJECT_MANAGER')) {
        v.searchValue = GreybeeRoles.PROJECT_MANAGER;
      } else if (v.searchValue == this.translateItems('greybee_roles', 'SENIOR_PROJECT_MANAGER')) {
        v.searchValue = GreybeeRoles.SENIOR_PROJECT_MANAGER;
      } else if (v.searchValue == this.translateItems('greybee_roles', 'SOFTWARE_DEVELOPER')) {
        v.searchValue = GreybeeRoles.SOFTWARE_DEVELOPER;
      }
    })
    return filterValues;
  }

  convertProjectTypes(filterValues: any): any {
    (filterValues).forEach((v: any) => {
      if (v.searchValue == this.translateItems('project_types', 'MIGRATION')) {
        v.searchValue = ProjectTypeEnum.MIGRATION;
      } else if (v.searchValue == this.translateItems('project_types', 'ORGANIZATION')) {
        v.searchValue = ProjectTypeEnum.ORGANIZATION;
      } else if (v.searchValue == this.translateItems('project_types', 'INFRASTRUCTURE')) {
        v.searchValue = ProjectTypeEnum.INFRASTRUCTURE;
      } else if (v.searchValue == this.translateItems('project_types', 'SOFTWARE_DEVELOPMENT')) {
        v.searchValue = ProjectTypeEnum.SOFTWARE_DEVELOPMENT;
      }
    })
    return filterValues;
  }

  convertProjectApproaches(filterValues: any): any {
    (filterValues).forEach((v: any) => {
      if (v.searchValue == this.translateItems('project_approaches', 'CLASSIC')) {
        v.searchValue = ProjectApproaches.CLASSIC;
      } else if (v.searchValue == this.translateItems('project_approaches', 'AGILE')) {
        v.searchValue = ProjectApproaches.AGILE
      } else if (v.searchValue == this.translateItems('project_approaches', 'HYBRID')) {
        v.searchValue = ProjectApproaches.HYBRID
      }
    })
    return filterValues;
  }

  startFreeSearch() {
    this.cvService.getCvsBySearchText({
      pageNumber: this.currentPage - 1,
      pageSize: this.itemsPerPage,
      text: this.simpleSearchForm.get('freeText').value
    }).subscribe((res: SearchDto[]) => {
      this.cvList = res;
      this.dataSource.data = this.cvList;
    });
  }

  onSubmit() {
    let searchTerms: any[] = this.searchCriteria.getRawValue();
    this.resetLists();

    searchTerms.forEach((t: any) => {
      switch (t.filterName) {
        case 'Rolle greybee':
          t.filterValues = this.convertGreybeeRoles(t.filterValues);
          break;
        case 'Projekttyp':
          t.filterValues = this.convertProjectTypes(t.filterValues);
          break;
        case 'Projektvorgehen':
          t.filterValues = this.convertProjectApproaches(t.filterValues);
          break;
        default:
          break;
      }
      this.fillFilterList(t);
    });

    this.cvService.getCvsBySearchTerms({
      pageNumber: this.currentPage - 1,
      pageSize: this.itemsPerPage,
      nameList: this.nameList_,
      lastnameList: this.lastnameList_,
      userroleList: this.userroleList_,
      branchList: this.branchList_,
      languageList: this.languageList_,
      certificateList: this.certificateList_,
      itcompetenceList: this.itcompetenceList_,
      professionalcompList: this.professionalcompList_,
      customerList: this.customerList_,
      projectTypeList: this.projectTypeList_,
      projectApproachList: this.projectApproachList_,
      projectroleList: this.projectroleList_,
      technologyList: this.technologyList_
    }).subscribe((res: SearchDto[]) => {
      this.cvList = res;
      this.convert();
    });
  }

  goToConsultantCvs(userId: number) {
    let url = 'cv-list/' + userId;
    window.open(url, '_blank');
  }

  goToCv(id: number, cvLang: string) {
    let lang = (cvLang === LanguageEnum.ENGLISH) ? 'en' : 'de';
    let url = 'cv-detail/' + lang + '/' + id;
    window.open(url, '_blank');
  }

  removeProfile(id: number, cvName: string) {
    this.userAccountService.getUserAccountById({id: id}).subscribe((res: UserAccountDto) => {
      let email = res.email;
      let warnMsg: string;
      this.translate.get('remove_profile_msg', {mail: email}).subscribe(text => warnMsg = text);
      this.dialog.open(ConfirmDeletionPopupComponent, {
        width: '370px',
        disableClose: true,
        autoFocus: false,
        position: {top: '20px'},
        data: {
          message: warnMsg
        }
      }).afterClosed().subscribe(isConfirmed => {
        if (isConfirmed) {
          this.userAccountService.deleteUserAccount({id: id}).subscribe(() => {
            this.allCvs.forEach((cv, i) => {
              if (cv.userAccountId == id) {
                this.allCvs.splice(i, 1);
              }
            })
            this.cvList.forEach((cv, i) => {
              if (cv.userAccountId == id) {
                this.cvList.splice(i, 1);
              }
            })
            this.dataSource.data = this.cvList;
            this.translate.get('profile_removed_success', cvName).subscribe(txt => this.toastrService.success(txt, cvName));
          }, (e) => {
            this.translate.get('profile_removed_error').subscribe(txt => this.toastrService.error(txt, cvName));
            console.log('Error! Failed to remove selected Profile', e);
          });
        }
      });
    });
  }

  fillFilterList(t: any): void {
    let tmpList: string[] = [];
    (t.filterValues).forEach((e: any) => {
      tmpList.push(e.searchValue);
    });
    switch (t.filterName) {
      case this.translateFilterName(SearchCriteriaEnum.FIRST_NAME):
        this.nameList_ = tmpList;
        break;

      case this.translateFilterName(SearchCriteriaEnum.LAST_NAME):
        this.lastnameList_ = tmpList;
        break;

      case this.translateFilterName(SearchCriteriaEnum.IT_SKILLS):
        this.itcompetenceList_ = tmpList;
        break;

      case this.translateFilterName(SearchCriteriaEnum.BRANCH_SKILLS):
        this.branchList_ = tmpList;
        break;

      case this.translateFilterName(SearchCriteriaEnum.ROLE_GREYBEE):
        this.userroleList_ = tmpList;
        break;

      case this.translateFilterName(SearchCriteriaEnum.ROLE_IN_PROJECT):
        this.projectroleList_ = tmpList;
        break;

      case this.translateFilterName(SearchCriteriaEnum.TECHNOLOGIES):
        this.technologyList_ = tmpList;
        break;

      case this.translateFilterName(SearchCriteriaEnum.PROJECT_TYPE):
        this.projectTypeList_ = tmpList;
        break;

      case this.translateFilterName(SearchCriteriaEnum.PROJECT_APPROACH):
        this.projectApproachList_ = tmpList;
        break;

      case this.translateFilterName(SearchCriteriaEnum.PROFESSIONAL_SKILLS):
        this.professionalcompList_ = tmpList;
        break;

      case this.translateFilterName(SearchCriteriaEnum.LANGUAGES_SKILLS):
        this.languageList_ = tmpList;
        break;

      case this.translateFilterName(SearchCriteriaEnum.CERTIFICATIONS):
        this.certificateList_ = tmpList;
        break;

      case this.translateFilterName(SearchCriteriaEnum.CUSTOMER):
        this.customerList_ = tmpList;
        break;
    }
  }

  onSearch(cvFilterModels: CvFilterModel[]): void {
    if (cvFilterModels) {
      cvFilterModels = cvFilterModels.filter(m => m.field && m.values)
      let cvFilterDtos: CvFilterDto[] = cvFilterModels.map(m => convertCvFilterModelToDto(m));
      this.cvService.getCvsByFilters({
        pageNumber: this.currentPage - 1,
        pageSize: this.itemsPerPage,
        body: cvFilterDtos
      }).subscribe((res: SearchDto[]) => {
        this.cvList = res;
        this.convert();
      });
    } else {
      this.cvService.getCvsBySearchText({
        pageNumber: this.currentPage - 1,
        pageSize: this.itemsPerPage,
        text: this.simpleSearchForm.get('freeText').value
      }).subscribe((res: SearchDto[]) => {
          this.cvList = res;
          this.convert();
          this.allCvs = this.cvList;
        },
        (e) => {
          console.log('Search error', e);
          this.toastrService.error('Suche kann nicht durchgeführt werden')
        }
      );
    }
  }
}
